import type {TCreateMajorActionData} from '@kapitalist/contract/types'
import {BY_ITSELF_PORTFOLIO_NEIGHBORHOOD_ID} from '~/game/types/neighborhoodId'
import type MajorAction from '~/models/game/MajorAction'

export const toCreateMajorActionData = (
  majorAction: MajorAction
): TCreateMajorActionData => {
  const {datasource} = majorAction

  // The model marks "a new set" with `BY_ITSELF_PORTFOLIO_NEIGHBORHOOD_ID`, but
  // the API takes a `destination` union instead.
  if (datasource.type === 'playToNeighborhood') {
    const {portfolioNeighborhoodId, ...rest} = datasource
    return {
      ...rest,
      destination:
        portfolioNeighborhoodId === BY_ITSELF_PORTFOLIO_NEIGHBORHOOD_ID
          ? {kind: 'newNeighborhood'}
          : {kind: 'existingNeighborhood', portfolioNeighborhoodId},
    }
  }

  if (datasource.type === 'doubleTheRent') {
    const {portfolioNeighborhoodId, ...rest} = datasource
    return rest
  }

  if ('millionsOwed' in datasource) {
    const {millionsOwed, ...rest} = datasource
    return rest
  }

  return datasource
}
